export class CoinExchangeRateResult {
    constructor() {
        this.apiResult = {};
        this.error = null;
        this.loaded = false;
    }
}
